import { REACT_APP_COGNITO_USER_POOL_CLIENT_ID } from '../../configs';
import { useCallback } from 'react';
import useError from '../useError/useError';
import { PATH_NAME } from '../../constant/location';
import { ERROR_CODE } from '../../constant/errorCode';
import { cognitoUtils } from '../../utils/auth/cognitoUtils';
import { cookieUtils } from '../../utils/storage/cookieUtils';
import { AxiosResponse } from 'axios';
import useSignOut from '../useSignout/useSignout';

const useErrorPage = () => {
  const { sendErrorLog } = useError();
  const { handleSignOut } = useSignOut();
  const apiErrorHandler = useCallback(
    async (e: any, options: { componentName: string; functionName: string }) => {
      let errorCode = '500_Internal_Server_Error';
      let forUserDisplayErrorCode = 'E_500';
      const rtn: AxiosResponse = {
        data: [] as never,
        status: 0,
        statusText: '',
        headers: '' as never,
        config: '' as never,
      };
      if (e.message) {
        const message = e.message as string;
        if (message.match(/401/)) {
          errorCode = '401_Unauthorized';
          await handleSignOut();
        } else if (message.match(/404/)) {
          errorCode = '404_Not_Found';
        }
      }
      if (options.componentName === PATH_NAME.TOP) {
        forUserDisplayErrorCode = 'E_401';
      }
      goErrorPage({ errorCode: forUserDisplayErrorCode });
    },
    [],
  );
  const goErrorPage = useCallback(
    async ({ errorCode = 'E_9000' }: { errorCode: string }) => {
      // エラー画面そのものでエラーになっても、遷移を繰り返さない
      if (window.location.pathname === PATH_NAME.ERROR) return;
      if (window.location.pathname === PATH_NAME.TOP) {
        sendErrorLog({
          error: '',
          errorCode: ERROR_CODE.HTTP_401,
          message: `${PATH_NAME.TOP}で異常発生。強制サインアウトします。`,
        });
        await handleSignOut();
        // 強制サインアウトのあとは、ページを再読み込みする
        window.location.href = '';
        return;
      }
      // アプリ内のエラー画面へ遷移する(ページを読み込み直して、エラーの状態を残さない)
      window.location.href = `${PATH_NAME.ERROR}?errorCode=${encodeURIComponent(errorCode)}`;
    },
    [sendErrorLog, handleSignOut],
  );
  return { goErrorPage, apiErrorHandler };
};
export default useErrorPage;
